import { graphql } from "@apollo/react-hoc"
import PERMISSIONS_QUERY from "./PermissionsQuery.gql.js"

const withPermissions = graphql(PERMISSIONS_QUERY, {
  props: ({ data }) => ({
    permissionsError: data.error,
    permissionsLoading: data.loading,
    permissions: data.currentUser?.permissions,
    availableProducts: data.currentUser?.availableProducts,
    canImpersonate: data.canImpersonate,
    isImpersonated: data.currentUser?.isImpersonated,
  }),
})

export default withPermissions
